import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from '../../services/store.service';
import { ModalService } from '../../services/modal.service';
import { ToolsService } from 'projects/shared/src/lib/services/tools.service';
import { MessagesService } from '../../services/messages.service';
import { CommunicationDAO, CommunicationsResDAO, NotificatioDAO, NotificationsResDAO } from '../../models/DAO/messagges';
import { AuthService } from '../../services/auth/auth.service';

@Component({
    selector: 'header-pre-head',
    templateUrl: './pre-head.component.html',
    styleUrls: ['./pre-head.component.scss'],
    standalone: false
})
export class PreHeadComponent implements OnInit {

  constructor(
    public router: Router,
    public translateService: TranslateService,
    public storeService: StoreService,
    public toolsService: ToolsService,
    public messageService: MessagesService,
    public modalService: ModalService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this._onInitCommunications();
      this._onInitNotifications();
    }, 2000);
  }
  _onInitCommunications() {
    this.messageService.communicationsNotReadCollection = [];
    this.messageService.getNewGenericCommunications().subscribe((res: CommunicationsResDAO) => {
      if(res && res.comunicazioni && res.comunicazioni.length > 0) {
        this.messageService.parsingCommunicationsHeaderCollection(res.comunicazioni);
      }
    });
  }
  _onInitNotifications() {
    this.messageService.notificationsNotReadCollection = [];
    this.messageService.getNewGenericNotifications().subscribe((res: NotificationsResDAO) => {
      if(res && res.notifiche && res.notifiche.length > 0) {
        this.messageService.parsingNotificationsHeaderCollection(res.notifiche);
      }
    });
  }
  openPreHeadModal(modalId: string, collectioNotReadLenght: number) {
    this.messageService.loadingOperation = false;
    if(collectioNotReadLenght > 0) {
      this.modalService.showModal(`custompopup-${modalId}`);
    } else {
      this.modalService.hideModal(`custompopup-${modalId}`);
      if (this.authService.isLogged()) {
        this.router.navigate([`${this.storeService.codIpa}/${modalId}/info`]);
      } else {
        this.router.navigate([`${modalId}/info`]);
      }
    }
  }
  closeModalAndGoToLink(modalId: string, url: string) {
    this.modalService.hideModal(`custompopup-${modalId}`);
    if (this.authService.isLogged()) {
      this.router.navigate([`${this.storeService.codIpa}/${url}`]);
    } else {
      this.router.navigate([`${url}`]);
    }
  }

  // COMMUNICATIONS
  checkCommunicationAsRead(item: CommunicationDAO, modalId: string) {
    if (this.authService.isLogged()) {
      this.checkCommunicationAsReadLogged(item, modalId);
    } else {
      this.checkCommunicationAsReadAnonymous(item, modalId, true);
    }
  }
  checkCommunicationAsReadLogged(item: CommunicationDAO, modalId: string) {
    this.messageService.loadingOperation = true;
    if(!item.letta) {
      this.messageService.checkMessageAsRead('communication', item.id)
      .subscribe({
        next: (res: any) => {
          this.messageService.loadingOperation = false;
          if(res && res == true) {
            this.checkCommunicationAsReadAnonymous(item, modalId, false);
            // this._onInitCommunications();
          }
        },
        error: (err) => {
          console.error(err)
          this.messageService.loadingOperation = false;
        }
      });
    }
  }
  checkCommunicationAsReadAnonymous(itemToRemove: CommunicationDAO, modalId: string, checkAndAddToLS: boolean) {
    this.messageService.loadingOperation = true;
    if(!itemToRemove.letta) {
      // Modifico elemento su header
      if(this.messageService.communicationsNotReadCollection.length > 0) {
        const index = this.messageService.communicationsNotReadCollection.findIndex((item: any) => item.id === itemToRemove.id);
        if (index !== -1) {
          const item = this.messageService.communicationsNotReadCollection[index];
          item.letta = true;
          this.messageService.numOfCommunications--;
          if(checkAndAddToLS === true) {
            this.messageService.addCommunicationToLS(item);
          }
        }
      }
      // Aggiorno elemento sulla pagina dedicata
      if(this.messageService.communicationsCollection.length > 0) {
        const index = this.messageService.communicationsCollection.findIndex((item: any) => item.id === itemToRemove.id);
        if (index !== -1) {
          this.messageService.communicationsCollection[index].letta = true;
        }
      }
      // Se non ho più elementi, chiudo popup
      if(this.messageService.communicationsNotReadCollection.length == 0) {
        this.modalService.hideModal(`custompopup-${modalId}`);
      }
      this.messageService.loadingOperation = false
    }
  }

  // NOTIFICATIONS
  checkNotificationAsRead(item: NotificatioDAO, modalId: string) {
    if (this.authService.isLogged()) {
      this.checkNotificationAsReadLogged(item, modalId);
    } else {
      this.checkNotificationAsReadAnonymous(item, modalId, true);
    }
  }
  checkNotificationAsReadLogged(item: NotificatioDAO, modalId: string) {
    this.messageService.loadingOperation = true;
    if(!item.letta) {
      this.messageService.checkMessageAsRead('notification', item.id)
      .subscribe({
        next: (res: any) => {
          this.messageService.loadingOperation = false;
          if(res && res == true) {
            this.checkNotificationAsReadAnonymous(item, modalId, false);
            // this._onInitNotifications();
          }
        },
        error: (err) => {
          console.error(err)
          this.messageService.loadingOperation = false
        }
      });
    }
  }
  checkNotificationAsReadAnonymous(itemToRemove: NotificatioDAO, modalId: string, checkAndAddToLS: boolean) {
    this.messageService.loadingOperation = true;
    if(!itemToRemove.letta) {
      // Modifico elemento su header
      if(this.messageService.notificationsNotReadCollection.length > 0) {
        const index = this.messageService.notificationsNotReadCollection.findIndex((item: any) => item.id === itemToRemove.id);
        if (index !== -1) {
          const item = this.messageService.notificationsNotReadCollection[index];
          item.letta = true;
          this.messageService.numOfNotifications--;
          if(checkAndAddToLS === true) {
            this.messageService.addNotificationToLS(item);
          }
        }
      }
      // Aggiorno elemento sulla pagina dedicata
      if(this.messageService.notificationsCollection.length > 0) {
        const index = this.messageService.notificationsCollection.findIndex((item: any) => item.id === itemToRemove.id);
        if (index !== -1) {
          this.messageService.notificationsCollection[index].letta = true;
        }
      }
      // Se non ho più elementi, chiudo popup
      if(this.messageService.notificationsNotReadCollection.length == 0) {
        this.modalService.hideModal(`custompopup-${modalId}`);
      }
      this.messageService.loadingOperation = false
    }
  }
}
